import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import fr from './locales/fr.json';
import es from './locales/es.json';

export const SUPPORTED_LANGUAGES = [
  { code: 'en', label: 'English', flagUrl: '/images/flags/us.svg' },
  { code: 'fr', label: 'Français', flagUrl: '/images/flags/fr.svg' },
  { code: 'es', label: 'Español', flagUrl: '/images/flags/es.svg' },
] as const;

export type LanguageCode = (typeof SUPPORTED_LANGUAGES)[number]['code'];

const DEFAULT_LANGUAGE: LanguageCode = 'en';

const stored = localStorage.getItem('crypxa_lang') as LanguageCode | null;
const initialLanguage =
  SUPPORTED_LANGUAGES.some((l) => l.code === stored) ? stored : DEFAULT_LANGUAGE;

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    fr: { translation: fr },
    es: { translation: es },
  },
  lng: initialLanguage,
  fallbackLng: DEFAULT_LANGUAGE,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
